var map = {
	"./en/drawers.json": [
		22448,
		2448
	],
	"./fr/drawers.json": [
		95311,
		5311
	],
	"./nl/drawers.json": [
		44561,
		4561
	],
	"./zh/drawers.json": [
		72585,
		4966
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 72009;
module.exports = webpackAsyncContext;